import isVideoCallDisabledByReed from './isVideoCallDisabledByReed';

const rules = [
  isVideoCallDisabledByReed,
];

const isGroupVideoCallDisabled = () => rules.some((rule) => rule());

export default isGroupVideoCallDisabled;
